import {match} from 'ts-pattern';

import {isNotNil} from 'ramda-adjunct';

import {featureFlags} from '@dms/feature-flags';

import {featureFlagsByAcl} from './featureFlagsByAcl';

// Custom notice permissions are registered per host entity as {HOST}_CUSTOM_NOTICE groups,
// so the whole family is gated by one flag through the shared suffix instead of an entity list
const CUSTOM_NOTICE_GROUP_ID_SUFFIX = '_CUSTOM_NOTICE';

export function resolveAclFeatureFlag(groupId: string) {
  return match(groupId)
    .when(
      (id) => isNotNil(featureFlagsByAcl[id]),
      (id) => featureFlagsByAcl[id]
    )
    .when(
      (id) => id.endsWith(CUSTOM_NOTICE_GROUP_ID_SUFFIX),
      () => featureFlags.CUSTOM_NOTICES
    )
    .otherwise(() => undefined);
}
